import { React, useEffect } from "react";
import PreviewImage from "./PreviewImage";
import PreviewShapes from "./PreviewShape";
import PreviewVideo from "./PreviewVideo";
import PreviewText from "./PreviewText";
import PreviewChangeableShapes from "./PreviewChangeableShapes";
import PreviewCharacter from "./PreviewCharacter";
import PreviewProps from "./PreviewProp";
import SoundPlay from "./PreviewSound";
import PreviewLottieTransition from "./PreviewLottieSlideTransition";

const clone = (obj) => {
  var copy;
  if (null === obj || "object" != typeof obj) return obj;
  if (obj instanceof Date) {
    copy = new Date();
    copy.setTime(obj.getTime());
    return copy;
  }
  if (obj instanceof Array) {
    copy = [];
    for (var i = 0, len = obj.length; i < len; i++) {
      copy[i] = clone(obj[i]);
    }
    return copy;
  }
  if (obj instanceof Object) {
    copy = {};
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
    }
    return copy;
  }
  throw new Error("Unable to copy obj! Its type isn't supported.");
};

const PreviewCanvas = ({
  setpopupload,
  DestroyPopup,
  setDestroyPopup,
  popupload,
  UnloadedCounter,
  setUnloadedCounter,
  LoadCounter,
  setLoadCounter,
  OnePx,
  SlideData,
  SupremeLayer,
  setSupremeLayer,
  TickerStart,
  TickerPosition,
  Play,
  TickerRef,
  setSlidesData,
  SlidesData,
  slides,
  isPlay,
  EditorZoom,
}) => {
  const calculateWidthByDuration = (duration) => {
    var tempArr = duration.split(":");
    var hours = parseInt(tempArr[0]);
    var minutes = parseInt(tempArr[1]);
    var seconds = parseInt(tempArr[2]);
    var milliseconds = parseInt(tempArr[3]);
    var totalMilliseconds =
      (hours * 60 * 60 + minutes * 60 + seconds) * 1000 + milliseconds;
    return Math.round(totalMilliseconds / OnePx); //onePxEquivalent
  };

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const msToTime2 = (s) => {
    function pad(n, z) {
      z = z || 2;
      return ("00" + n).slice(-z);
    }
    var ms = s % 1000;
    s = (s - ms) / 1000;
    var secs = s % 60;
    s = (s - secs) / 60;
    var mins = s % 60;
    var hrs = (s - mins) / 60;
    return (
      pad(hrs) +
      ":" +
      pad(mins) +
      ":" +
      pad(secs) +
      ":" +
      pad(Math.round(ms), 3)
    );
  };

  const calculateTimeByWidth = (width) => {
    let ms = parseFloat((width * OnePx).toFixed(3));
    return msToTime2(ms);
  };

  const totalTimeToMs = (TotalLength) => {
    let timeSplitted = TotalLength.split(":");
    let hours = parseInt(timeSplitted[0]);
    let mins = parseInt(timeSplitted[1]);
    let sec = parseInt(timeSplitted[2]);
    let ms = parseInt(timeSplitted[3]);
    let hoursToMs = hours * 60 * 60 * 1000;
    let minsToMs = mins * 60 * 1000;
    let secToMs = sec * 1000;
    return hoursToMs + minsToMs + secToMs + ms;
  };

  useEffect(() => {
    if (OnePx) {
      const array = SlideData;

      for (let i = 0; i < array.length; i++) {
        // array[i].widthOnTimeline = (Math.round(array[i].widthOnTimeline / OnePx))
        // array[i].startPositionOnTimeline = (Math.round(array[i].startPositionOnTimeline / OnePx))

        // if(array[i].time)
        // {
        //     array[i].LastStartPositionOnTimeline = (Math.round(array[i].LastStartPositionOnTimeline / OnePx))
        // }

        array[i].endTransitionWidth = calculateWidthByDuration("00:00:00:500");

        if (
          array[i].InEffect != "animated TextBounce " &&
          array[i].InEffect != "animated TypeWriter " &&
          array[i].InEffect != "animated WordByWordFade " &&
          array[i].InEffect != "animated WordByWordAppear "
        ) {
          array[i].startTransitionWidth =
            calculateWidthByDuration("00:00:00:500");
        }
      }

      // for (let i = 0; i < array.length; i++) {
      //     let types = array[i].InEffect
      //     if (types == "animated TextBounce " || types == "animated Rolling " || types == "animated TypeWriter ") {
      //         var txt = array[i].text;
      //         let charactersArray = [];
      //         let cleanCharacterArray = [];
      //         let character = '';
      //         let calculatedTime = 0;

      //         for (let j = 0; j < txt.length; j++) {
      //             if (txt.charAt(j) == "<"
      //                 && txt.charAt(j + 1).toLowerCase() == "b"
      //                 && txt.charAt(j + 2).toLowerCase() == "r"
      //                 && txt.charAt(j + 3).toLowerCase() == ">") {
      //                 let obj = {
      //                     id: `wbwf_${makeid(8)}`,
      //                     character: character,
      //                     next: "<br>",
      //                     startAt: calculatedTime
      //                 }
      //                 if (character != "") {
      //                     calculatedTime += 40;
      //                     cleanCharacterArray.push(obj);
      //                 }
      //                 charactersArray.push(obj);
      //                 character = "";
      //                 j = j + 3;
      //             }
      //             else if (txt.charAt(j) == "&"
      //                 && txt.charAt(j + 1).toLowerCase() == "n"
      //                 && txt.charAt(j + 2).toLowerCase() == "b"
      //                 && txt.charAt(j + 3).toLowerCase() == "s"
      //                 && txt.charAt(j + 4).toLowerCase() == "p"
      //                 && txt.charAt(j + 5).toLowerCase() == ";") {
      //                 let obj = {
      //                     id: `wbwf_${makeid(8)}`,
      //                     character: character,
      //                     next: "&nbsp;",
      //                     startAt: calculatedTime
      //                 }
      //                 if (character != "") {
      //                     calculatedTime += 40;
      //                     cleanCharacterArray.push(obj);
      //                 }
      //                 charactersArray.push(obj);
      //                 character = "";
      //                 j = j + 5;
      //             }
      //             else if (txt.charAt(j) == " ") {
      //                 let obj = {
      //                     id: `wbwf_${makeid(8)}`,
      //                     character: character,
      //                     next: " ",
      //                     startAt: calculatedTime
      //                 }
      //                 if (character != "") {
      //                     calculatedTime += 40;
      //                     cleanCharacterArray.push(obj);
      //                 }
      //                 charactersArray.push(obj);
      //                 character = "";
      //                 // j = j + 6;
      //             }
      //             else {
      //                 if (character != "") {
      //                     let obj = {
      //                         id: `wbwf_${makeid(8)}`,
      //                         character: character,
      //                         next: "",
      //                         startAt: calculatedTime
      //                     }
      //                     if (character != "") {
      //                         calculatedTime += 40;
      //                         cleanCharacterArray.push(obj);
      //                     }
      //                     charactersArray.push(obj);
      //                 }
      //                 character = txt.charAt(j);
      //             }
      //         }

      //         if (character != "") {
      //             let obj = {
      //                 id: `wbwf_${makeid(8)}`,
      //                 character: character,
      //                 next: "",
      //                 startAt: calculatedTime
      //             }
      //             if (character != "") {
      //                 calculatedTime += 40;
      //                 cleanCharacterArray.push(obj);
      //             }
      //             charactersArray.push(obj);
      //         }
      //         array[i].CharactersArray = charactersArray;
      //         array[i].cleanCharacterArray = cleanCharacterArray;
      //         array[i].startTransitionWidth = calculateWidthByDuration(msToTime2(calculatedTime));
      //         let minMsPrLetter = totalTimeToMs(calculateTimeByWidth(array[i].startTransitionWidth)) / cleanCharacterArray.length;
      //         if (array[i].startTransitionWidth > (Number(TickerRef.current.max) - array[i].endTransitionWidth)) {
      //             minMsPrLetter = totalTimeToMs(calculateTimeByWidth(Number(TickerRef.current.max) - array[i].endTransitionWidth)) / cleanCharacterArray.length;
      //             array[i].startTransitionWidth = Number(TickerRef.current.max) - array[i].endTransitionWidth; //calculateWidthByDuration(msToTime2(calculatedTime));
      //         }
      //         array[i].bounceInMs = minMsPrLetter;
      //         if (minMsPrLetter < 20) {
      //             alert("can not set transition: " + minMsPrLetter)
      //         }
      //     }
      //     else if (types == "animated WordByWordFade ") {
      //         var txt = array[i].text;
      //         let wordsArray = [];
      //         let cleanWordsArray = [];
      //         let word = '';
      //         let CalculatedTime = 0;
      //         let opacityIncrement = 0.03;
      //         let perWordFPS = 60;
      //         let perWordTimeout = (1 / opacityIncrement) * perWordFPS;
      //         let perWordMS = 200;

      //         for (let j = 0; j < txt.length; j++) {
      //             if (txt.charAt(j) == "<"
      //                 && txt.charAt(j + 1).toLowerCase() == "b"
      //                 && txt.charAt(j + 2).toLowerCase() == "r"
      //                 && txt.charAt(j + 3).toLowerCase() == ">") {
      //                 let obj = {
      //                     id: `wbwf_${makeid(8)}`,
      //                     word: word,
      //                     next: "<br>",
      //                     startAt: CalculatedTime
      //                 }
      //                 if (word != "") {
      //                     CalculatedTime += (perWordTimeout - (perWordTimeout - perWordMS))
      //                     cleanWordsArray.push(obj);
      //                 }
      //                 wordsArray.push(obj);
      //                 word = "";
      //                 j = j + 3;
      //             }
      //             else if (txt.charAt(j) == "&"
      //                 && txt.charAt(j + 1).toLowerCase() == "n"
      //                 && txt.charAt(j + 2).toLowerCase() == "b"
      //                 && txt.charAt(j + 3).toLowerCase() == "s"
      //                 && txt.charAt(j + 4).toLowerCase() == "p"
      //                 && txt.charAt(j + 5).toLowerCase() == ";") {
      //                 let obj = {
      //                     id: `wbwf_${makeid(8)}`,
      //                     word: word,
      //                     next: "&nbsp;",
      //                     startAt: CalculatedTime
      //                 }
      //                 if (word != "") {
      //                     CalculatedTime += (perWordTimeout - (perWordTimeout - perWordMS))
      //                     cleanWordsArray.push(obj);
      //                 }
      //                 wordsArray.push(obj);
      //                 word = "";
      //                 j = j + 5;
      //             }
      //             else if (txt.charAt(j) == " ") {
      //                 let obj = {
      //                     id: `wbwf_${makeid(8)}`,
      //                     word: word,
      //                     next: " ",
      //                     startAt: CalculatedTime
      //                 }
      //                 if (word != "") {
      //                     CalculatedTime += (perWordTimeout - (perWordTimeout - perWordMS))
      //                     cleanWordsArray.push(obj);
      //                 }
      //                 wordsArray.push(obj);
      //                 word = "";
      //                 // j = j + 6;
      //             }
      //             else {
      //                 word += txt.charAt(j);
      //             }
      //         }
      //         if (word != "") {
      //             let obj = {
      //                 id: `wbwf_${makeid(8)}`,
      //                 word: word,
      //                 next: "",
      //                 startAt: CalculatedTime
      //             }
      //             if (word != "") {
      //                 CalculatedTime += (perWordTimeout - (perWordTimeout - perWordMS))
      //                 cleanWordsArray.push(obj);
      //             }
      //             wordsArray.push(obj);
      //             word = "";
      //         }

      //         array[i].WordsArray = wordsArray;
      //         array[i].startTransitionWidth = calculateWidthByDuration(msToTime2(CalculatedTime));

      //         //check if full width is smaller than transition then make it dynamic

      //         if (array[i].startTransitionWidth > (Number(TickerRef.current.max) / 2)) {
      //             let MaxTotalMs = (Number(TickerRef.current.max) / 2) * OnePx;
      //             let maxPerWordMs = MaxTotalMs / cleanWordsArray.length;
      //             let downSizePercentage = maxPerWordMs / perWordMS;
      //             let upsizeOpacityIncrement = (opacityIncrement * (1 - downSizePercentage)) + opacityIncrement;
      //             opacityIncrement = upsizeOpacityIncrement;
      //             perWordFPS = (60 * (1 - downSizePercentage)) + 60;
      //             perWordTimeout = (1 / opacityIncrement) * perWordFPS;
      //             perWordMS = maxPerWordMs;
      //             wordsArray = [];
      //             cleanWordsArray = [];
      //             CalculatedTime = 0;

      //             for (let j = 0; j < txt.length; j++) {
      //                 if (txt.charAt(j) == "<"
      //                     && txt.charAt(j + 1).toLowerCase() == "b"
      //                     && txt.charAt(j + 2).toLowerCase() == "r"
      //                     && txt.charAt(j + 3).toLowerCase() == ">") {
      //                     let obj = {
      //                         id: `wbwf_${makeid(8)}`,
      //                         word: word,
      //                         next: "<br>",
      //                         startAt: CalculatedTime
      //                     }
      //                     if (word != "") {
      //                         CalculatedTime += (perWordTimeout - (perWordTimeout - perWordMS))
      //                         cleanWordsArray.push(obj);
      //                     }
      //                     wordsArray.push(obj);
      //                     word = "";
      //                     j = j + 3;
      //                 }
      //                 else if (txt.charAt(j) == "&"
      //                     && txt.charAt(j + 1).toLowerCase() == "n"
      //                     && txt.charAt(j + 2).toLowerCase() == "b"
      //                     && txt.charAt(j + 3).toLowerCase() == "s"
      //                     && txt.charAt(j + 4).toLowerCase() == "p"
      //                     && txt.charAt(j + 5).toLowerCase() == ";") {
      //                     let obj = {
      //                         id: `wbwf_${makeid(8)}`,
      //                         word: word,
      //                         next: "&nbsp;",
      //                         startAt: CalculatedTime
      //                     }
      //                     if (word != "") {
      //                         CalculatedTime += (perWordTimeout - (perWordTimeout - perWordMS))
      //                         cleanWordsArray.push(obj);
      //                     }
      //                     wordsArray.push(obj);
      //                     word = "";
      //                     j = j + 5;
      //                 }
      //                 else if (txt.charAt(j) == " ") {
      //                     let obj = {
      //                         id: `wbwf_${makeid(8)}`,
      //                         word: word,
      //                         next: " ",
      //                         startAt: CalculatedTime
      //                     }
      //                     if (word != "") {
      //                         CalculatedTime += (perWordTimeout - (perWordTimeout - perWordMS))
      //                         cleanWordsArray.push(obj);
      //                     }
      //                     wordsArray.push(obj);
      //                     word = "";
      //                 }
      //                 else {
      //                     word += txt.charAt(j);
      //                 }
      //             }
      //             if (word != "") {
      //                 let obj = {
      //                     id: `wbwf_${makeid(8)}`,
      //                     word: word,
      //                     next: "",
      //                     startAt: CalculatedTime
      //                 }
      //                 if (word != "") {
      //                     CalculatedTime += (perWordTimeout - (perWordTimeout - perWordMS))
      //                     cleanWordsArray.push(obj);
      //                 }
      //                 wordsArray.push(obj);
      //                 word = "";
      //             }
      //         }

      //         array[i].wordByWordFadeInData = {
      //             CalculatedTime: CalculatedTime,
      //             opacityIncrement: opacityIncrement,
      //             perWordFPS: perWordFPS,
      //             perWordTimeout: perWordTimeout,
      //             perWordMS: perWordMS,
      //             cleanWordsArray: cleanWordsArray
      //         };

      //         array[i].WordsArray = wordsArray;
      //         array[i].startTransitionWidth = calculateWidthByDuration(msToTime2(CalculatedTime + perWordMS));
      //     }
      //     else if (types == "animated WordByWordAppear ") {
      //         var txt = array[i].text;
      //         let wordsArray = [];
      //         let cleanWordsArray = [];
      //         let word = '';
      //         let CalculatedTime = 0;
      //         let opacityIncrement = 0.03;
      //         let perWordFPS = 60;
      //         let perWordTimeout = (1 / opacityIncrement) * perWordFPS;
      //         let perWordMS = 2000;

      //         for (let j = 0; j < txt.length; j++) {
      //             if (txt.charAt(j) == "<"
      //                 && txt.charAt(j + 1).toLowerCase() == "b"
      //                 && txt.charAt(j + 2).toLowerCase() == "r"
      //                 && txt.charAt(j + 3).toLowerCase() == ">") {
      //                 let obj = {
      //                     id: `wbwf_${makeid(8)}`,
      //                     word: word,
      //                     next: "<br>",
      //                     startAt: CalculatedTime
      //                 }
      //                 if (word != "") {
      //                     CalculatedTime += perWordTimeout;
      //                     cleanWordsArray.push(obj);
      //                 }
      //                 wordsArray.push(obj);
      //                 word = "";
      //                 j = j + 3;
      //             }
      //             else if (txt.charAt(j) == "&"
      //                 && txt.charAt(j + 1).toLowerCase() == "n"
      //                 && txt.charAt(j + 2).toLowerCase() == "b"
      //                 && txt.charAt(j + 3).toLowerCase() == "s"
      //                 && txt.charAt(j + 4).toLowerCase() == "p"
      //                 && txt.charAt(j + 5).toLowerCase() == ";") {
      //                 let obj = {
      //                     id: `wbwf_${makeid(8)}`,
      //                     word: word,
      //                     next: "&nbsp;",
      //                     startAt: CalculatedTime
      //                 }
      //                 if (word != "") {
      //                     CalculatedTime += perWordTimeout;
      //                     cleanWordsArray.push(obj);
      //                 }
      //                 wordsArray.push(obj);
      //                 word = "";
      //                 j = j + 5;
      //             }
      //             else if (txt.charAt(j) == " ") {
      //                 let obj = {
      //                     id: `wbwf_${makeid(8)}`,
      //                     word: word,
      //                     next: " ",
      //                     startAt: CalculatedTime
      //                 }
      //                 if (word != "") {
      //                     CalculatedTime += perWordTimeout;
      //                     cleanWordsArray.push(obj);
      //                 }
      //                 wordsArray.push(obj);
      //                 word = "";
      //                 // j = j + 6;
      //             }
      //             else {
      //                 word += txt.charAt(j);
      //             }
      //         }
      //         if (word != "") {
      //             let obj = {
      //                 id: `wbwf_${makeid(8)}`,
      //                 word: word,
      //                 next: "",
      //                 startAt: CalculatedTime
      //             }
      //             if (word != "") {
      //                 CalculatedTime += perWordTimeout;
      //                 cleanWordsArray.push(obj);
      //             }
      //             wordsArray.push(obj);
      //             word = "";
      //         }

      //         array[i].WordsArray = wordsArray;
      //         array[i].startTransitionWidth = calculateWidthByDuration(msToTime2(CalculatedTime));

      //         if (array[i].startTransitionWidth > (Number(TickerRef.current.max) / 2)) {
      //             let MaxTotalMs = (Number(TickerRef.current.max) / 2) * OnePx;
      //             let maxPerWordMs = MaxTotalMs / cleanWordsArray.length;
      //             let downSizePercentage = maxPerWordMs / perWordMS;
      //             let upsizeOpacityIncrement = (opacityIncrement * (1 - downSizePercentage)) + opacityIncrement;
      //             opacityIncrement = upsizeOpacityIncrement;
      //             perWordFPS = maxPerWordMs / 60;  //(60 * (1 - downSizePercentage)) + 60;
      //             perWordTimeout = (1 / opacityIncrement) * perWordFPS;
      //             perWordMS = maxPerWordMs;
      //             wordsArray = [];
      //             cleanWordsArray = [];
      //             CalculatedTime = 0;

      //             for (let j = 0; j < txt.length; j++) {
      //                 if (txt.charAt(j) == "<"
      //                     && txt.charAt(j + 1).toLowerCase() == "b"
      //                     && txt.charAt(j + 2).toLowerCase() == "r"
      //                     && txt.charAt(j + 3).toLowerCase() == ">") {
      //                     let obj = {
      //                         id: `wbwf_${makeid(8)}`,
      //                         word: word,
      //                         next: "<br>",
      //                         startAt: CalculatedTime
      //                     }
      //                     if (word != "") {
      //                         CalculatedTime += perWordMS;
      //                         cleanWordsArray.push(obj);
      //                     }
      //                     wordsArray.push(obj);
      //                     word = "";
      //                     j = j + 3;
      //                 }
      //                 else if (txt.charAt(j) == "&"
      //                     && txt.charAt(j + 1).toLowerCase() == "n"
      //                     && txt.charAt(j + 2).toLowerCase() == "b"
      //                     && txt.charAt(j + 3).toLowerCase() == "s"
      //                     && txt.charAt(j + 4).toLowerCase() == "p"
      //                     && txt.charAt(j + 5).toLowerCase() == ";") {
      //                     let obj = {
      //                         id: `wbwf_${makeid(8)}`,
      //                         word: word,
      //                         next: "&nbsp;",
      //                         startAt: CalculatedTime
      //                     }
      //                     if (word != "") {
      //                         CalculatedTime += perWordMS;
      //                         cleanWordsArray.push(obj);
      //                     }
      //                     wordsArray.push(obj);
      //                     word = "";
      //                     j = j + 5;
      //                 }
      //                 else if (txt.charAt(j) == " ") {
      //                     let obj = {
      //                         id: `wbwf_${makeid(8)}`,
      //                         word: word,
      //                         next: " ",
      //                         startAt: CalculatedTime
      //                     }
      //                     if (word != "") {
      //                         CalculatedTime += perWordMS;
      //                         cleanWordsArray.push(obj);
      //                     }
      //                     wordsArray.push(obj);
      //                     word = "";
      //                 }
      //                 else {
      //                     word += txt.charAt(j);
      //                 }
      //             }
      //             if (word != "") {
      //                 let obj = {
      //                     id: `wbwf_${makeid(8)}`,
      //                     word: word,
      //                     next: "",
      //                     startAt: CalculatedTime
      //                 }
      //                 if (word != "") {
      //                     CalculatedTime += perWordMS;
      //                     cleanWordsArray.push(obj);
      //                 }
      //                 wordsArray.push(obj);
      //                 word = "";
      //             }
      //         }
      //         let scaleDecriment = 10 / (1 / opacityIncrement)
      //         array[i].wordByWordFadeInData = {
      //             CalculatedTime: CalculatedTime,
      //             opacityIncrement: opacityIncrement,
      //             perWordFPS: perWordFPS,
      //             perWordTimeout: perWordTimeout,
      //             perWordMS: perWordMS,
      //             cleanWordsArray: cleanWordsArray,
      //             scaleDecriment: scaleDecriment
      //         };
      //         array[i].WordsArray = wordsArray;
      //         array[i].startTransitionWidth = calculateWidthByDuration(msToTime2(CalculatedTime + perWordMS));
      //     }

      // }

      setSupremeLayer({ ...SupremeLayer, Layer: array });
      setSlidesData(array);
    }
  }, [OnePx]);

  return (
    <>
      {SlidesData.length > 0 &&
        SlidesData.map((value, index) => {
          const zInd = index + 1;

          return (
            <>
              {value.type === "Shape" && (
                <PreviewShapes
                  setLoadCounter={setLoadCounter}
                  value={value}
                  TickerStart={TickerStart}
                  TickerPosition={TickerPosition}
                  zInd={zInd}
                  CanvasDisplay={Play}
                />
              )}
              {value.type === "Video" && (
                <PreviewVideo
                  setLoadCounter={setLoadCounter}
                  value={value}
                  onePx={OnePx}
                  TickerStart={TickerStart}
                  TickerPosition={TickerPosition}
                  zInd={zInd}
                  CanvasDisplay={Play}
                  index={index}
                />
              )}
              {value.type === "image" && (
                <PreviewImage
                  setLoadCounter={setLoadCounter}
                  value={value}
                  TickerStart={TickerStart}
                  TickerPosition={TickerPosition}
                  zInd={zInd}
                  CanvasDisplay={Play}
                />
              )}

              {value.type === "text" && (
                <PreviewText
                  value={value}
                  TickerStart={TickerStart}
                  TickerPosition={TickerPosition}
                  zInd={zInd}
                  CanvasDisplay={Play}
                  index={index}
                  OnePx={OnePx}
                  EditorZoom={EditorZoom}
                />
              )}

              {value.type === "basicShape" && (
                <PreviewChangeableShapes
                  value={value}
                  TickerStart={TickerStart}
                  TickerPosition={TickerPosition}
                  zInd={zInd}
                  CanvasDisplay={Play}
                  index={index}
                  EditorZoom={EditorZoom}
                />
              )}

              {value.type === "Character" && (
                <PreviewCharacter
                  setLoadCounter={setLoadCounter}
                  value={value}
                  onePX={OnePx}
                  TickerStart={TickerStart}
                  key={index}
                  TickerPosition={TickerPosition}
                  TickerRef={TickerRef}
                  SlideData={SlideData}
                  zInd={zInd}
                  SlidesData={SlidesData}
                  setSlidesData={setSlidesData}
                  CanvasDisplay={Play}
                  index={index}
                  JSONValue={value.JSONValue}
                />
              )}

              {value.type === "AnimatedText" && (
                <PreviewCharacter
                  setLoadCounter={setLoadCounter}
                  value={value}
                  onePX={OnePx}
                  TickerStart={TickerStart}
                  key={index}
                  TickerPosition={TickerPosition}
                  TickerRef={TickerRef}
                  SlideData={SlideData}
                  zInd={zInd}
                  SlidesData={SlidesData}
                  setSlidesData={setSlidesData}
                  CanvasDisplay={Play}
                  index={index}
                  JSONValue={value.JSONValue}
                  isAnimatedText={true}
                />
              )}

              {value.type === "SlideTransition" && (
                <PreviewLottieTransition
                  UnloadedCounter={UnloadedCounter}
                  setUnloadedCounter={setUnloadedCounter}
                  LoadCounter={LoadCounter}
                  setLoadCounter={setLoadCounter}
                  value={value}
                  onePX={OnePx}
                  TickerStart={TickerStart}
                  TickerPosition={TickerPosition}
                  zInd={zInd}
                  CanvasDisplay={Play}
                  index={index}
                />
              )}

              {value.type === "Props" && (
                <>
                  <PreviewProps
                    UnloadedCounter={UnloadedCounter}
                    setUnloadedCounter={setUnloadedCounter}
                    LoadCounter={LoadCounter}
                    setLoadCounter={setLoadCounter}
                    value={value}
                    TickerStart={TickerStart}
                    TickerPosition={TickerPosition}
                    zInd={zInd}
                    CanvasDisplay={Play}
                    index={index}
                    onePX={OnePx}
                  />
                </>
              )}
              {/* {value.type === "audio" && <>
                    <SoundPlay setpopupload={setpopupload} DestroyPopup={DestroyPopup} setDestroyPopup={setDestroyPopup} popupload={popupload}
                        UnloadedCounter={UnloadedCounter} setUnloadedCounter={setUnloadedCounter} LoadCounter={LoadCounter} setLoadCounter={setLoadCounter}
                        onePxEquivalent={OnePx} value={value} Play={Play} isPlay = {isPlay}
                        CurrentPositionOfTicker = {TickerRef.current?.value}
                        TickerStart={TickerStart} TickerPosition={TickerPosition} zInd={zInd} CanvasDisplay={Play} ComingFrom = {"PreivewCanvas"} />
                </> } */}
            </>
          );
        })}
      {SlidesData.length === 0 && <div></div>}
    </>
  );
};
export default PreviewCanvas;
